<template>
    <v-row justify="center">
        <v-dialog v-model="openModal" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeMaterialsModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Entrega de Materiais</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <template>
                    <MaterialList ref="movement" :idMaterials="idMaterials" :list="materials.movements" :add="addMovement" @loading="is_loading" :remove="removeMovement"/>
                </template>

                <template v-if="!isFranchisee">
                  <NextStepProject
                    :loading="is_loading"
                    :disabled="!enableNextStepButton || isFranchisee"
                    :message="buttonMessage"
                    :click="activateWaterFixStep"
                  />
              </template>
              <AverageNextStep
                ref="averageModal"
                :model-value="showAverageNextStep"
                :next-step="nextStepVariable"  
              />
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import Materials from "./Materials.js"

export default Materials
</script>

<style scoped></style>
